import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="M" transform="translate(11.000000, 5.000000)">
        <path
          d="M0.360,28.784 L6.539,28.784 L8.218,8.977 L12.438,28.784 L16.852,28.784 L20.878,9.020 
          L22.622,28.784 L29.081,28.784 L25.808,0.042 L17.390,0.042 L16.120,6.501 C15.789,8.151 15.481,9.845 
          15.194,11.582 L14.483,16.039 C13.808,11.575 12.883,6.242 11.706,0.042 L3.460,0.042 L0.360,28.784 Z"
          fill="currentColor"
          transform="rotate(0 0 0)translate(25, 30)"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
